import React, { useEffect,useRef,  useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { FaArrowUp } from "react-icons/fa";
import { fetchStateDisData } from '../Actions/Action_TableData'
import Moment from 'react-moment';
import TestCards from './state_Tests_cards';
import moment from 'moment';
function StateTable() {
const StateData = useSelector(state => state.InfoCardData.FullData); 
const [lastUpdated, set_lastUpdated] = useState(null);
const [selectedState, set_selectedState] = useState("");
const StateDisData = useSelector(state => state.StateDisTable.state_dis);
const ZoneInfo = useSelector(state => state.StateDisTable.zone_info);
const dispatch = useDispatch();
const MainTable = (
    <table class="table table-bordered shadow tableD"   >
    <thead class="thead-dark">
        <tr>
                 <th class="fixedCol" scope="col">STATE</th>
                 <th scope="col">CONFIRMED</th>
                 <th scope="col">ACTIVE</th>
                 <th scope="col">RECOVERED</th>
                 <th scope="col">DEATH</th>
        </tr>
    </thead>
    <tbody>
    {StateData != undefined ?
            StateData.map(item1 => (  
                    <>
                        <tr >
                            <td  class="Zone fixedCol" style={{background:'rgba(128, 128, 128, 0.12)',fontWeight:'700',color:'grey'}} >
                                <button value = {item1.state} class="tblStateButton"
                                     onClick={ (e) =>  {
                                                        selectedState != e.target.value
                                                        ?
                                                        dispatch(fetchStateDisData(e.target.value, item1.lastupdatedtime))
                                                        :
                                                        dispatch(fetchStateDisData(""))
                                                        set_lastUpdated(item1.lastupdatedtime);
                                                        set_selectedState(e.target.value)                                                       
                                                        }}>
                                         {item1.state.toUpperCase()}
                                </button>
                            </td>
                          
                            {item1.deltaconfirmed != 0 ? 
                            <td class="tabletd">{item1.confirmed} 
                                <span class="activeInc" >
                                            <FaArrowUp /> {item1.deltaconfirmed}
                                </span> 
                            </td>:
                            <td class="tabletd">{item1.confirmed}</td>
                            }
                            <td class="tabletd">{item1.active}</td>
                            {item1.deltarecovered != 0 ? 
                            <td class="tabletd">{item1.recovered}
                              <span style={{color:'green',float:'right'}} >
                                            <FaArrowUp /> {item1.deltarecovered}
                              </span> 
                            </td>:
                            <td class="tabletd">{item1.recovered}</td>
                            }
                            {item1.deltadeaths != 0 ? 
                            <td class="tabletd">{item1.deaths}
                            <span style={{color:'gray',float:'right'}} >
                                            <FaArrowUp /> {item1.deltadeaths}
                            </span> 
                            </td>:
                            <td class="tabletd">{item1.deaths}</td>
                            }
                        </tr>   
                    { 
                        StateDisData != undefined ? 
                        StateDisData.map(states =>
                          states.statecode.toLowerCase() === item1.statecode.toLowerCase() ?
                          <tr >
                              <td colSpan="5">
                               <TestCards />

                        <table class = "table table-bordered shadow tableD" > 
                           <thead class="thead-dark">
                                 <tr>
                                    <th class="fixedCol" scope="col">DISTRICT</th>
                                    <th scope="col">CONFIRMED</th>
                                    <th scope="col">ACTIVE</th>
                                    <th scope="col">REC</th>
                                    <th scope="col">DEATH</th>
                                </tr>
                            </thead>
                            <tbody>
                            {states.districtData.map(districts =>
                            <> 
                            
                                <tr id={states.state}>
                                    {
                                        ZoneInfo.filter(vendor => vendor.district === districts.district).length > 0 ? 
                                         ZoneInfo.map(zone_dis =>
                                            (zone_dis.district === districts.district?
                                                // set_unknownDist(true)
                                                zone_dis.zone === 'Red' ?
                                                <td class="Zone " style={{background:'#ff00004a', color:'#a20000'}}>
                                                    {districts.district.toUpperCase()}
                                                </td>
                                                :
                                                zone_dis.zone === 'Orange' ?
                                                        <td class="Zone"  style={{background:'rgba(255, 94, 0, 0.25)', color:'#ff3b00'}}>
                                                                {districts.district.toUpperCase()}
                                                        </td>
                                                :
                                                zone_dis.zone === 'Green' ?
                                                    <td class="Zone" style={{background:'#00800038', color:'green'}}>
                                                            {districts.district.toUpperCase()}
                                                    </td>
                                                :
                                                ""
                                            : 
                                            ""
                                            
                                            )
                                        )
                                        :
                                        <td class="tabletd">  {districts.district}</td>
                                    }         
                                            {districts.delta.confirmed != 0 ?
                                            <td class="tabletd">{districts.confirmed}
                                                <span class="activeInc" >
                                                            <FaArrowUp /> {districts.delta.confirmed}
                                                </span>
                                            </td>
                                            :
                                            <td class="tabletd">{districts.confirmed}
                                            </td>
                                            
                                            }
                                            <td class="tabletd">{districts.active}</td>

                                            {districts.delta.recovered != 0 ?
                                            <td class="tabletd">{districts.recovered}
                                                <span  style={{color:'green',float:'right'}}>
                                                            <FaArrowUp /> {districts.delta.recovered}
                                                </span>
                                            </td>
                                            :
                                            <td class="tabletd">{districts.recovered}
                                            </td>
                                            
                                            }

                                             {districts.delta.deceased != 0 ?
                                            <td class="tabletd">{districts.deceased}
                                                <span  style={{color:'grey',float:'right'}}>
                                                            <FaArrowUp /> {districts.delta.deceased}
                                                </span>
                                            </td>
                                            :
                                            <td class="tabletd">{districts.deceased}
                                            </td>
                                            
                                            }
                                          
                                           
                                
                                </tr> 
                            
                             </>  
                            
                            )}
                            </tbody>
                            </table>  
                              </td>
                          </tr>
                            :''
                        
                        )
                        :''
                    } 
                       
                    </>
                ),
                )  
                :
                ""
            }        
    </tbody>
</table>
)
  return(
   <div class="table-responsive">
       {MainTable}
    </div>
  )
}
export default StateTable